import React, { Component } from "react";
import Header from "../../components/header/Header";
// import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
// import ExperienceAccordion from "../../containers/experienceAccordion/ExperienceAccordion.js";
import "./Experience.css";
import { experience } from "../../portfolio.js";
import { Fade } from "react-reveal";
import ExperienceImg from "./ExperienceImg";
import { Panel } from "baseui/accordion";
import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";

class Experience extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="experience-main">
        <Header theme={theme} />
        <div className="basic-experience">
          <Fade bottom duration={2000} distance="40px">
            <div className="experience-heading-div">
              <div className="experience-heading-img-div">
                {/* <img
									src={require(`../../assets/images/${experience["header_image_path"]}`)}
									alt=""
								/> */}
                <ExperienceImg theme={theme} />
              </div>
              <div className="experience-heading-text-div">
                <h1
                  className="experience-heading-text"
                  style={{ color: theme.text }}
                >
                  {experience.title}
                </h1>
                <h3
                  className="experience-heading-sub-text"
                  style={{ color: theme.text }}
                >
                  {experience["subtitle"]}
                </h3>
                <p
                  className="experience-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {experience["description"]}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        <Panel
          className="accord-panel"
          title={experience["sections"][0]["title"]}
          // key={experience["sections"][0]["index"]}
          overrides={{
            Header: {
              style: () => ({
                backgroundColor: `${theme.body}`,
                border: `1px solid`,
                borderRadius: `5px`,
                borderColor: `${theme.headerColor}`,
                marginBottom: `3px`,
                fontFamily: "Google Sans Regular",
                color: `${theme.text}`,
                ":hover": {
                  color: `${theme.secondaryText}`,
                },
              }),
            },
            Content: {
              style: () => ({
                backgroundColor: `${theme.body}`,
              }),
            },
          }}
        >
          {experience["sections"].map((experience, index) => {
            return (
              <ExperienceCard
                index={index}
                totalCards={experience["sections"].length}
                experience={experience}
                theme={theme}
              />
            );
          })}
        </Panel>
        {/* <ExperienceAccordion sections={experience["sections"]} theme={theme} /> */}
        {/* <Footer theme={this.props.theme} onToggle={this.props.onToggle} /> */}
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Experience;
